
interface NVCookieHelpers {
    deleteCookie(name: string): void;
    getCookie(cname: string): string | undefined;
    setCookie(name: string, value: string): void;
}
const cartKey = 'nvHeadless';
const nvCookieHelpers: NVCookieHelpers = {
    deleteCookie(name) {
        if (window?.location.host.indexOf('localhost') > -1) {
            document.cookie = `${name}=; Max-Age=0; path=/`;
        } else {
            document.cookie = `${name}=; Max-Age=0; path=/; domain=.nvidia.com`;
        }
    },
    getCookie(cname) {
        let _state: any;
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                _state = c.substring(name.length, c.length);
            }
        }

        if (cname === cartKey && _state && _state !== undefined) {
            try {
                const obj = JSON.parse(_state);
                if (obj.cart && obj.cart.length > 0) {
                    for (let i = 0; i < obj.cart.length; i++) {
                        if (obj.cart[i] && obj.cart[i].name) {
                            try {
                                console.log('Headless Cart Item', obj.cart[i].name, decodeURI(atob(obj.cart[i].name)))
                                obj.cart[i].name = decodeURI(atob(obj.cart[i].name));
                            } catch (err) {
                                console.log(err, obj.cart[i]);
                            }
                        } else {
                            obj.cart.splice(i, 1);
                            i--;
                        }
                    }
                }
                _state = obj;
            } catch (err) {
                console.error(err);
            }
        }
        return _state;
    },

    setCookie(name, value) {
        const date = new Date();
        date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
        let expires;
        try {
            const obj = JSON.parse(value);
            if (obj.cart && obj.cart.length > 0) {
                for (let i = 0; i < obj.cart.length; i++) {
                    if (obj.cart[i] && obj.cart[i].name) {
                        try {
                            obj.cart[i].name = btoa(encodeURI(obj.cart[i].name));
                        } catch (err) {
                            console.log(err, obj.cart[i]);
                        }
                    } else {
                        obj.cart.splice(i, 1);
                        i--;
                    }
                }
            }
            value = obj;
        } catch (err) {
            console.log(err);
        }
        if (name === 'sessionDetails') {
            expires = `; expires=${date.toUTCString()}`;
        } else {
            expires = ';expires=Thu, 01 Jan 2060 00:00:01 GMT';
        }
        if (window?.location.host.indexOf('localhost') > -1) {
            document.cookie = `${name}=${JSON.stringify(value)}${expires};path=/`;
        } else {
            document.cookie = `${name}=${JSON.stringify(value)}${expires};domain=.nvidia.com;path=/;secure`;
        }
    }
};

export default nvCookieHelpers;
